import {Formik} from "formik";
import {Col, Container, Form, Row} from "react-bootstrap";

import {FormattedMessage} from "react-intl";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {AlertError} from "../bootstrap/AlertError";
import {TextAreaInputField} from "../bootstrap/TextAreaInputField";
import {MultipleUploadArea} from "../MultipleUploadArea";
import {
    addAppealDocument,
    addDecisionDocument,
    appeal,
    deleteAppealDocument,
    deleteDecisionDocument
} from "../../rest/entity";
import {DocumentType} from "../../models/DocumentType";


export function EaADAppealForm ({entityNif, onCancel, onSubmitCallback, documents, setDocuments}) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [navErrors, setNavErrors] = useState([]);
    const navigate = useNavigate();


    async function onSubmit(values, setSubmitting, setErrors) {
        setSubmitting(true);
        const dto = {appealComment: values.text};
        console.log('dto', dto);

        try {
            await appeal(entityNif, dto);
            onSubmitCallback?.()
            setSubmitted(true);
            sessionStorage.setItem('eaAccreditationAppealed', true);
        } catch (error) {
            console.log(error);
            setErrors(error);
        }
        setSubmitting(false);
    }

    const validationSchema = yup.object().shape({
        text: yup
            .string()
            .typeError(<FormattedMessage id='errors.fieldRequiredText'/>)
            .required(<FormattedMessage id='errors.fieldRequiredText'/>),

    });


    const initialValues = {
        text: null
    };



    function validation (values, props) {
        const errors = {};
        // if(documents.length === 0 || !documents.map(d => d.documentType).includes(DocumentType.EAA_APPEAL_DOCUMENT)){
        //     errors.documents = <FormattedMessage id='need.documents'/>;
        // }
        return errors;
    }

    return (
        <>
            <AlertError error={error} />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validate={validation}
                validateOnChange={false}
                onSubmit={(values, { setSubmitting, setErrors }) => {
                    onSubmit(values, setSubmitting, setErrors);
                }}>
                {({ values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <AlertError error={errors} />
                        <Row>

                            <Col>
                                <TextAreaInputField
                                    controlId={'text'}
                                    label={<FormattedMessage id='candidatureTabs.oversight.tabs.noncompliance.appeal.text' /> }
                                    name={'text'}
                                    handleChange={({target}) => setFieldValue('text', target.value)}
                                    errorMessage={errors.text}
                                />
                            </Col>
                        </Row>


                        <Row className='mt-3'>
                            <Col>
                                <label>
                                    <FormattedMessage id='documents.list' />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <MultipleUploadArea
                                    documents={documents}
                                    documentType={DocumentType.EAA_APPEAL_DOCUMENT}
                                    setDocuments={setDocuments}
                                    acceptExtensions='.pdf,.docx'
                                    uploadCallback={(formData) => addDecisionDocument(entityNif, formData)}
                                    deleteCallback={(documentExternalId) => deleteDecisionDocument(entityNif, documentExternalId)}
                                />
                                {"documents" in errors &&
                                    <Form.Control.Feedback type='invalid'>{errors.documents}</Form.Control.Feedback>
                                }
                            </Col>
                        </Row>

                        <Row className='form-actions'>
                            <Col className='justify-content-between d-flex'>
                                <button className='btn btn-outline-primary' type='button' onClick={() => onCancel?.()}>
                                    <FormattedMessage id='all.cancel' />
                                </button>
                                <button className='btn btn-primary' type='submit' >
                                    <FormattedMessage id='all.submitButtonText' />
                                </button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
}